import { render } from "./SerproConfig.vue?vue&type=template&id=03f56dc7"
import script from "./SerproConfig.vue?vue&type=script&lang=js"
export * from "./SerproConfig.vue?vue&type=script&lang=js"

import "./SerproConfig.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__